// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
}

:root {
  --light-gray: rgb(45, 45, 45);
  --dark-gray: rgb(33, 33, 33);
}

html,
body {
  height: 100%;
}

body {
  display: grid;
  grid-template: 1fr 8fr / 1fr 4fr;
}

#logo {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  background-color: var(--dark-gray);
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 5px solid black;
}

#logo h2 {
  padding: 25px;
  color: white;
}

#banner {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  background-color: var(--dark-gray);
  border-bottom: 5px solid black;
}

#info {
  grid-column: 1 / 2;
  grid-row: 2 / 3;
  background-color: var(--dark-gray);
  display: flex;
  flex-direction: column;
  align-items: center;
}

#info h2 {
  padding: 25px;
  color: white;
  text-align: center;
}

#info p {
  padding: 25px;
  color: white;
  font-weight: bold;
}

#info img {
  margin: 25px;
}

#content {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  background-color: var(--light-gray);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

#output {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  flex-grow: 1;
  width: 50%;
  max-height: 60vh;
  overflow-y: auto;
  padding: 20px;
}

.user {
  color: white;
  margin-bottom: 15px;
  align-self: flex-end;
}

.ai {
  color: white;
  margin-bottom: 15px;
  align-self: flex-start;
  font-weight: bold;
}

#input {
  margin-bottom: 25px;
}

label {
  color: white;
  font-weight: bolder;
  font-size: large;
}

#question {
  background-color: var(--dark-gray);
  border: 0px solid;
  border-radius: 25px;
  padding: 15px;
  padding-right: 30px;
  color: white;
}

#question:focus {
  outline: 2px solid black;
}

#btn {
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 25px;
  background-color: var(--dark-gray);
  color: white;
  border: 0px;
  transition: all 0.5s 0s;
}

#btn:hover {
  background-color: rgb(25, 25, 25);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-in {
  animation: fadeIn 0.25s ease-in;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  font-family: \"Roboto\", sans-serif;\n}\n\n:root {\n  --light-gray: rgb(45, 45, 45);\n  --dark-gray: rgb(33, 33, 33);\n}\n\nhtml,\nbody {\n  height: 100%;\n}\n\nbody {\n  display: grid;\n  grid-template: 1fr 8fr / 1fr 4fr;\n}\n\n#logo {\n  grid-column: 1 / 2;\n  grid-row: 1 / 2;\n  background-color: var(--dark-gray);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 5px solid black;\n}\n\n#logo h2 {\n  padding: 25px;\n  color: white;\n}\n\n#banner {\n  grid-column: 2 / 3;\n  grid-row: 1 / 2;\n  background-color: var(--dark-gray);\n  border-bottom: 5px solid black;\n}\n\n#info {\n  grid-column: 1 / 2;\n  grid-row: 2 / 3;\n  background-color: var(--dark-gray);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#info h2 {\n  padding: 25px;\n  color: white;\n  text-align: center;\n}\n\n#info p {\n  padding: 25px;\n  color: white;\n  font-weight: bold;\n}\n\n#info img {\n  margin: 25px;\n}\n\n#content {\n  grid-column: 2 / 3;\n  grid-row: 2 / 3;\n  background-color: var(--light-gray);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n\n#output {\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n  flex-grow: 1;\n  width: 50%;\n  max-height: 60vh;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.user {\n  color: white;\n  margin-bottom: 15px;\n  align-self: flex-end;\n}\n\n.ai {\n  color: white;\n  margin-bottom: 15px;\n  align-self: flex-start;\n  font-weight: bold;\n}\n\n#input {\n  margin-bottom: 25px;\n}\n\nlabel {\n  color: white;\n  font-weight: bolder;\n  font-size: large;\n}\n\n#question {\n  background-color: var(--dark-gray);\n  border: 0px solid;\n  border-radius: 25px;\n  padding: 15px;\n  padding-right: 30px;\n  color: white;\n}\n\n#question:focus {\n  outline: 2px solid black;\n}\n\n#btn {\n  padding: 10px;\n  padding-left: 20px;\n  padding-right: 20px;\n  border-radius: 25px;\n  background-color: var(--dark-gray);\n  color: white;\n  border: 0px;\n  transition: all 0.5s 0s;\n}\n\n#btn:hover {\n  background-color: rgb(25, 25, 25);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.25s ease-in;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
